import createReactComponent from '../createReactComponent';
var ChevronsUpDown = createReactComponent('ChevronsUpDown', [['path', {
  d: 'M7 15l5 5 5-5',
  key: '5x0lmt'
}], ['path', {
  d: 'M7 9l5-5 5 5',
  key: '1q9c92'
}]]);
export default ChevronsUpDown;